import { Slider } from "./style";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/a11y";
import Wharley from "../../../../assets/depoimentos/WharleySilva.webp";
import Wladimir from "../../../../assets/depoimentos/WladimirMachado.webp";
import Stacey from "../../../../assets/depoimentos/StaceyToddStout.webp";
import Joao from "../../../../assets/depoimentos/JoaoRicardo.webp";
import Marcelo from "../../../../assets/depoimentos/MarceloBrandao.webp";
import { FiArrowUpRight } from "react-icons/fi"


function SliderComponent() {
  const db = [
    {
      nome: "Wharley Silva",
      cargo: "Continuous Improvement Manager (Expat) Tower Internacional",
      company: "Tower Internacional",
      depoimento:
        "“O método de ensino mais focado na prática e no dia a dia do que precisávamos, me ajudou a dominar o idioma e a deixar de temer tanto nas conferências, ou mesmo lidando com os estrangeiros durante o trabalho. Consegui aprovação para Mestrado, conclui minhas pós graduações com extensão no exterior e hoje trabalho fora do país.”",
      img: Wharley,
      id: 0,
    },
    {
      nome: "Wladimir Machado",
      cargo: "CEO da WT Comex ",
      company: "Presidente da CAMEX Alto Tietê e V. Paraíba",
      depoimento:
        "“A metodologia aplicada pelo Flávio é ímpar! O estudo de idiomas se torna divertido, dinâmico e o mais importante, realmente entrega resultados em um curto prazo de tempo. Recomendo a todos, o Flávio é 10!!!”",
      img: Wladimir,
      id: 1,
    },
    {
      nome: "Stacey Todd Stout",
      cargo: "Controller USA",
      company: "Sage Automotive Interiors",
      depoimento:
        "“O Flávio me ajudou a me comunicar em português no trabalho, em restaurantes, lojas, em viagens ao Rio de Janeiro e outras cidades. Hoje, eu consigo me comunicar com brasileiros e está muito mais fácil.”",
      img: Stacey,
      id: 2,
    },
    {
      nome: "João Ricardo",
      cargo: "Diretor Executivo no Instituto Plenna",
      company: "Empresário, Palestrante e Treinador",
      depoimento:
        "“Flávio contribuiu significativamente para o desenvolvimento de minha capacidade de comunicação na língua inglesa. Havia estudado em escolas tradicionais e o método criado por ele foi muito mais eficiente e rápido que os métodos que conheço.”",
      img: Joao,
      id: 3,
    },
    {
      nome: "Marcelo Brandão",
      cargo: "Gerente de Qualidade",
      company: "KF Estamparia",
      depoimento:
        "“O ritmo de aprendizado é rápido e os resultados são muitos positivos. E em se tratando de preços, achei que o custo benefício é compensador, tendo em vista comparações com outras escolas de idiomas.”",
      img: Marcelo,
      id: 4,
    },
  ];

  const width = window.innerWidth;
  let thisWidth2 = 1.05;

  if (width > 1000) {
    thisWidth2 = 3.05;
  } else if (width > 600) {
    thisWidth2 = 2.05;
  }

  return (
    <Slider>
      <div id="see-title">
        <span id="conf">Confiança e honestidade</span>
        <div id="see">
          <h1>Veja alguma das histórias de sucesso..</h1>
          <button><a href="https://www.flavio-moura.com/depoimentos" target="blank">Ver todos os depoimentos <FiArrowUpRight/></a></button>
        </div>
      </div>
      <Swiper
        id="slider"
        spaceBetween={5}
        slidesPerView={thisWidth2}
        pagination={true}
        loop={true}
        a11y={true}
        modules={[Pagination, A11y, Autoplay]}
        autoplay={true}
      >
        {db.map((people) => (
          <SwiperSlide className="slides" key={people.id}>
            <div className="id">
              <figure>
                <img src={people.img} alt="Imagem" />
              </figure>
              <div>
                <h1>{people.nome}</h1>
                <h3>{people.cargo}</h3>
                <h3>{people.company}</h3>
              </div>
            </div>
            <div className="depoiment">
              <p>{people.depoimento}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </Slider>
  );
}

export default SliderComponent;
